export default __webpack_public_path__ + "static/media/permeable-aqualina-dark-grey-pewter.e5e2b213.jpg";